const authRoutes = [
  {
    path: "/auth/:tag",
    name: "auth",
    meta: { public: true },
    component: () => import("../../views/auth/index.vue"),
  },
];
export default authRoutes;
